import axios from 'axios';
import { axiosInstance } from '../Axios';
const { createSlice } = require('@reduxjs/toolkit');

const HotelReducer = createSlice({
	name: 'Hotel',
	initialState: {
		success: false,
		error: null,
		orderID: null,
		loadinghotel: false,
		loadinghoteldes: false,
		hotelcity: null,
		hotelresult: null,
	},
	reducers: {
		cityHotelRequest(state, action) {
			state.loadinghotel = true;
		},
		cityHotelSuccess(state, action) {
			state.loadinghotel = false;
			state.hotelcity = action.payload;
			state.error = null;
		},
		cityHotelFail(state, action) {
			state.loadinghotel = false;
			state.error = action.payload;
		},
		hotelSearchRequest(state, action) {
			state.loadinghotel = true;
		},
		hotelSearchSuccess(state, action) {
			state.loadinghotel = false;
			state.hotelresult = action.payload;
			state.error = null;
		},
		hotelSearchFail(state, action) {
			state.loadinghotel = false;
			state.error = action.payload;
		},
	},
});
const config = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjO7hqe3PG9musafi==',
	},
};
const config2 = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'Client-Service': 'srk-client',
		'Auth-Key': 'srkapi',
		'Api-Key': 'NjA4MzFiNDBkZmI1NQ==',
	},
};
const { actions } = HotelReducer;

export const {
	cityHotelRequest,
	cityHotelSuccess,
	cityHotelFail,
	hotelSearchRequest,
	hotelSearchSuccess,
	hotelSearchFail,
} = actions;

export const fetchHotelCityDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(hotelSearchSuccess(null));
		dispatch(cityHotelRequest());
		const { data } = await axiosInstance.post(
			'home/hotelcity',
			bodyData,
			config
		);
		console.log(data);
		dispatch(cityHotelSuccess(data));
	} catch (error) {
		dispatch(
			cityHotelFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const hotelSearchDispatch = (bodyData, history) => async (dispatch) => {
	try {
		dispatch(hotelSearchRequest());
		const { data } = await axios.post(
			'https://flight.marinersforex.com/api/hoteltbo/search',
			bodyData,
			config2
		);

		console.log(data);
		dispatch(hotelSearchSuccess(data));
	} catch (error) {
		dispatch(
			hotelSearchFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export default HotelReducer;
